import { render, staticRenderFns } from "./AppSticky.vue?vue&type=template&id=45766c2c"
import script from "./AppSticky.vue?vue&type=script&lang=js"
export * from "./AppSticky.vue?vue&type=script&lang=js"
import style0 from "./AppSticky.vue?vue&type=style&index=0&id=45766c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports